import { Authenticator, useAuthenticator } from "@aws-amplify/ui-react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function Signin() {
  const { user } = useAuthenticator((context) => [context.user]);
  const navigate = useNavigate();
  const { state } = useLocation();

  useEffect(() => {
    if (user) {
      const targetLocation = state?.prevLocation || "/";
      navigate(targetLocation);
    }
  }, [user, navigate, state]);

  return <Authenticator variation="default" hideSignUp={true}></Authenticator>;
}

export default Signin;
